/* eslint-disable*/
import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import ModalTabs from "../Procedimientos/modal";

const ModalProcedimientos = ({ toggle, procedimientos, client, isAdmin, isOwner }) => {
  console.log("MODALTAB", client);
  return (
    <>
      <Modal className="modal-lg" centered isOpen toggle={toggle}>
        <ModalTabs toggle={toggle} clientId={client} procedimientos={procedimientos} isAdmin={isAdmin} isOwner={isOwner} />
      </Modal>
    </>
  );
};

export default ModalProcedimientos;
